<template>
  <div class="row">
    <div class="col-md-5 col-md-offset-3">
      <WdsHeading as="h1" type="title1">
        {{ $t('Verify your email address') }}
      </WdsHeading>

      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsText class="tw-mb-6" secondary>
        {{ $t('Some features in Worksome requires that you confirm your email address.') }}
      </WdsText>

      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsText class="tw-mt-1" secondary>
        {{
          $t(
            'If you do not receive the email in your inbox, make sure to also check your spam folder.',
          )
        }}
      </WdsText>

      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsAlert v-if="hasVerifiedEmail === true" error>
        {{ $t('Your email is already verified') }}
      </WdsAlert>

      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsAlert v-if="status !== ''" class="tw-mt-6">
        {{ status }}
      </WdsAlert>

      <div class="text-center tw-mt-6">
        <WdsButton
          primary
          full-width
          :disabled="success || hasVerifiedEmail === true"
          @click="sendEmailVerify"
        >
          {{ $t('Send confirmation email') }}
        </WdsButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import gql from 'graphql-tag'
import { WdsButton, WdsHeading } from '@worksome/wds-components'
import { computed, ref } from 'vue'
import { useMutation, useQuery } from '@vue/apollo-composable'
import { $t } from '@/composables/translation'

const success = ref(false)
const status = ref('')

const { result } = useQuery(
  gql`
    query hasVerifiedEmail {
      profile {
        hasVerifiedEmail
      }
    }
  `,
  {},
  {
    clientId: 'publicApi',
  },
)
const hasVerifiedEmail = computed(() => result.value?.profile?.hasVerifiedEmail ?? null)

const { mutate: sendVerificationEmail } = useMutation(
  gql`
    mutation verify {
      sendVerificationEmail {
        id
      }
    }
  `,
  {
    clientId: 'publicApi',
  },
)

async function sendEmailVerify() {
  await sendVerificationEmail()
  success.value = true
  status.value = $t('A verification email has been sent.')
}
</script>

<style scoped></style>
